module.exports = __webpack_public_path__ + "static/media/DgSetIcon.722d7a17.svg";